import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'archive',
    appAlias: summit.RESOURCE.payload.alias,
    description: 'Archive for organizing and storing important notes',
    display: {
      isMain: true,
      position: 3,
    },
    name: 'Archive',
    page: { id: prebuilt.Page.Id.SummitArchive },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
